import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKeyboardDown"><Path fillRule="evenodd" clipRule="evenodd" d="M1 2V16H23V2H1ZM9 10H15V12H9V10ZM7 6H5V8H7V6ZM5 10H7V12H5V10ZM11 6H9V8H11V6ZM13 6H15V8H13V6ZM19 6H17V8H19V6ZM17 10H19V12H17V10Z" fill="currentColor"/><Path d="M12.0002 19.5859L10.0002 17.5859L8.58594 19.0002L12.0002 22.4144L15.4144 19.0002L14.0002 17.5859L12.0002 19.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboardDown;
